import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core'
import { FormGroup, FormControl } from '@angular/forms'
import { ParsedGooglePlace, countries, SaveForm } from '@tokeet-frontend/tv3-platform'
import { GpsLocation } from '@tv3/shared/map-control/map-control.component'

@Component({
  selector: 'app-bdc-create-property-address',
  templateUrl: './bdc-create-property-address.component.html',
})
export class BdcCreatePropertyAddressComponent implements OnInit {
  @Input() form: FormGroup
  @Output() prev = new EventEmitter<void>()
  @Output() next = new EventEmitter<void>()

  get physicalAddressForm() {
    return this.form.get('physical_address') as FormGroup
  }

  @Input() isLoading = false

  positionControl = new FormControl()

  constructor() {
    // Subscribe to position control changes to update the form
    this.positionControl.valueChanges.subscribe((location: GpsLocation) => {
      if (location) {
        this.form.get('position').patchValue({
          latitude: location.lat,
          longitude: location.long,
        })
      }
    })
  }

  ngOnInit() {
    // Initialize position control with form values
    const position = this.form.get('position').value
    if (position) {
      this.positionControl.setValue({
        lat: position.latitude,
        long: position.longitude,
      })
    }
  }

  onPlaceChange(parsedPlace: ParsedGooglePlace) {
    const country = countries.find((c) => c.id === parsedPlace.countryShort)
    this.physicalAddressForm.patchValue({
      address_line: (parsedPlace.streetNumber ? parsedPlace.streetNumber + ' ' : '') + (parsedPlace.street || ''),
      city_name: parsedPlace.city,
      country_code: country?.id,
      postal_code: parsedPlace.postCode,
    })

    this.positionControl.setValue({
      lat: parsedPlace.gps.lat,
      long: parsedPlace.gps.long,
    })
  }

  @SaveForm()
  onSave(form: FormGroup) {
    this.next.emit()
  }
}
